import React from 'react';
import { useEffect } from 'react';
import blogTopics from '../data/blogTopics';
import fukahireProfile from '../img/Fukahire4.webp';
import rinIcon from '../img/Rurune_Rin.webp';
import vrcWorldRinRoom from '../img/vrcWld1.png';
import vrcWorldSleep from '../img/vrcWld2.png';
import '../Style/VrchatProfile.css';

const worlds = [
  {
    name: 'RinRoom',
    label: 'Private room',
    image: vrcWorldRinRoom,
    url: 'https://vrchat.com/home/world/wrld_23ce6296-db36-4de4-bcdc-3b16beeccee4',
  },
  {
    name: '-Sleep with you-',
    label: 'Sleep world',
    image: vrcWorldSleep,
    url: 'https://vrchat.com/home/world/wrld_b08614dc-6a4b-4b6c-9845-6e7148408d98',
  },
];

const activity = [
  ['Active time', 'Night / Weekend'],
  ['Style', 'Chill / Quiet / Creative'],
  ['Tools', 'UNITY, BLENDER'],
  ['Company', '...'],
];

const music = [
  {
    title: 'Favorite music 1',
    src: 'https://www.youtube.com/embed/E_pv5ASvz0c',
  },
  {
    title: 'Favorite music 2',
    src: 'https://www.youtube.com/embed/ni2pGkTPLDo',
  },
];

function VrchatProfile() {
  useEffect(() => {
    const revealItems = Array.from(
      document.querySelectorAll('.vrchat-scroll-reveal')
    );

    if (!revealItems.length) {
      return undefined;
    }

    const prefersReducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      revealItems.forEach((item) => item.classList.add('is-visible'));
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      {
        rootMargin: '0px 0px -18% 0px',
        threshold: 0.18,
      }
    );

    revealItems.forEach((item) => observer.observe(item));

    return () => observer.disconnect();
  }, []);

  return (
    <main className="vrchat-official">
      <nav className="vrchat-site-nav" aria-label="VRChat profile navigation">
        <a href="/">HOME</a>
        <a href="#profile">PROFILE</a>
        <a href="#worlds">WORLDS</a>
        <a href="#topics">TOPICS</a>
        <a href="#music">MUSIC</a>
        <a href="#contact">CONTACT</a>
      </nav>
      <img
        className="vrchat-character-layer"
        src={rinIcon}
        alt=""
        aria-hidden="true"
      />

      <section
        className="vrchat-official-hero vrchat-scroll-reveal"
        aria-labelledby="vrchat-title"
      >
        <div className="vrchat-hero-text">
          <p className="vrchat-role">UnityEngineer/XR/U#</p>
          <h1 id="vrchat-title">
            <span>RIN</span>
          </h1>
          <p className="vrchat-lead">
            <span>なでる、なでられる。V睡するのが好きです。</span>
            <span>夜に少人数で遊べるようなフレンドがほしいです。</span>
            <span>
              VRChatでは、SanrioVirtualPurolandの制作、管理に携わっています。
            </span>
            <span>普段はルルネ、すやすやうさぎ、アルエを使っています。</span>
          </p>
          <div className="vrchat-hero-actions">
            <a
              href="https://x.com/rin_0700"
              target="_blank"
              rel="noopener noreferrer"
            >
              @rin0700
            </a>
            <a
              href="https://x.com/liy_MV"
              target="_blank"
              rel="noopener noreferrer"
            >
              @liyMV
            </a>
            <a href="/blog">Blog</a>
          </div>
        </div>

        <div className="vrchat-hero-meta" aria-label="プロフィール概要">
          {activity.map(([label, value]) => (
            <div key={label}>
              <span>{label}</span>
              <strong>{value}</strong>
            </div>
          ))}
        </div>
      </section>

      <div className="vrchat-marquee" aria-label="最新のお知らせ">
        <span>
          RIN VRCHAT PROFILE / WORLD VISIT OPEN / CHILL NIGHT SPACE / AVATAR
          CUSTOM / MUSIC & SLEEP WORLD /
        </span>
      </div>

      <section
        className="vrchat-section vrchat-profile-band vrchat-scroll-reveal"
        id="profile"
        aria-labelledby="profile-title"
      >
        <div className="vrchat-profile-side">
          <div className="vrchat-section-title">
            <span>01</span>
            <h2 id="profile-title">PROFILE</h2>
          </div>
          <img
            className="vrchat-profile-image"
            src={fukahireProfile}
            alt="Fukahire avatar"
          />
        </div>
        <div className="vrchat-profile-copy">
          <p className="vrchat-profile-text">
            {`VRChat:
  2023/03 Start プレイ時間: 12,000
  平日22時以降、土日祝17時以降でinしています。
  寝る時間は24~27時の間です。
  少人数で遊ぶのが好きです、仕事の関係でオレンジが多いですがinvite送っていただけたらいつでも行きます！
  （ステータスが仕事中の場合は厳しいかもです。）
  いつでもフレンド募集しています！(`}
            <a
              href="https://vrchat.com/home/user/usr_c08af74f-c1bc-4ba6-b4d2-ba0eeeec7844"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://vrchat.com/home/user/usr_c08af74f-c1bc-4ba6-b4d2-ba0eeeec7844
            </a>
            {`)

  趣味：音楽、温泉、自作関係、Webデザイン
  Skrillexが大好きです。来日してほしい;;
  キーボード、ケーブル、PCなど作っています。
  OSとかも作ってみたいけど難しそうでやってないです。

  Work:
  25卒 満23歳
  UnityエンジニアでVRChatTeamに入っています。
  ポートフォリオ・実績はこちら\u3000（`}
            <a href="/works">rin0700.com/works</a>
            {`）
  お仕事のご依頼はこちらへ (`}
            <a href="/mail">rin0700.com/mail</a>
            {`) 仕事内容によりますがVRChat関係であれば受けれます。
  会議などは平日18:30~対応できます。
  WorldギミックやUI関係が得意です、Avatarはそこまで詳しくないです。
  HLSL勉強中`}
          </p>
        </div>
      </section>

      <section
        className="vrchat-section vrchat-scroll-reveal"
        id="worlds"
        aria-labelledby="worlds-title"
      >
        <div className="vrchat-section-title">
          <span>02</span>
          <h2 id="worlds-title">WORLDS</h2>
        </div>
        <div className="vrchat-world-showcase">
          {worlds.map((world) => (
            <a
              className="vrchat-world"
              href={world.url}
              target="_blank"
              rel="noopener noreferrer"
              key={world.name}
            >
              <img
                src={world.image}
                alt={`${world.name}のスクリーンショット`}
              />
              <span>
                <small>{world.label}</small>
                <strong>{world.name}</strong>
              </span>
            </a>
          ))}
        </div>
      </section>

      <section
        className="vrchat-section vrchat-scroll-reveal"
        id="topics"
        aria-labelledby="topics-title"
      >
        <div className="vrchat-section-title">
          <span>03</span>
          <h2 id="topics-title">TOPICS</h2>
        </div>
        <div className="vrchat-topic-list">
          {blogTopics.map((topic) => (
            <a
              className="vrchat-topic"
              href={topic.url}
              target={topic.external ? '_blank' : undefined}
              rel={topic.external ? 'noopener noreferrer' : undefined}
              key={topic.title}
            >
              <img src={topic.image} alt={topic.alt} />
              <span>BLOG</span>
              <time>{topic.category}</time>
              <h3>{topic.title}</h3>
            </a>
          ))}
        </div>
      </section>

      <section
        className="vrchat-section vrchat-scroll-reveal"
        id="music"
        aria-labelledby="music-title"
      >
        <div className="vrchat-section-title">
          <span>04</span>
          <h2 id="music-title">Favorite Music</h2>
        </div>
        <div className="vrchat-music-grid">
          {music.map((item) => (
            <iframe
              key={item.src}
              src={item.src}
              title={item.title}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            />
          ))}
        </div>
      </section>

      <footer className="vrchat-footer" id="contact">
        <strong>RIN VRCHAT PROFILE</strong>
        <a
          href="https://x.com/rin_0700"
          target="_blank"
          rel="noopener noreferrer"
        >
          @rin0700
        </a>
        <a
          href="https://x.com/liy_MV"
          target="_blank"
          rel="noopener noreferrer"
        >
          @liyMV
        </a>
      </footer>
    </main>
  );
}

export default VrchatProfile;
